import React, { useRef, useState }  from 'react'

import TransferFromSB from './TransferFromSB'
import TransferToSB from './TransferToSB'
import TransferTypeSB from './TransferTypeSB'

import { createTransferService } from "../../../services/transfer.service";
import { v4 as uuidv4 } from "uuid";
import { setIsLoading, setToastMessage } from "../../../reducers/common.reducer";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FaSpinner } from 'react-icons/fa';

const TransferAtoU = (props) => {

    const { transferFromData, transferToData, transferTypeData, expandTo, setExpandTo } = props;

    const [transferType, setTransferType] = useState({'transactionTypeId': '', 'transactionType' : 'Transfer Type'});
    const [transferFrom, setTransferFrom] = useState({'agentId': '', 'agentName' : 'From'});
    const [transferTo, setTransferTo] = useState({'userId': '', 'username' : 'To'});
    const [amount, setAmount] = useState(0);

    const [expandTransferType, setExpandTransferType] = useState(false);
    const [expandFrom, setExpandFrom] = useState(false);
    const [errors, setErrors] = useState({});
    const [isSubimtting, setIsSubmitting] = useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const inputRef = useRef(null);
    const handleWheel = (event) => event.target.blur();

    const handleFocus = () => {
        inputRef.current.select();
    };

    const selectTransferType=(e)=>{
        e.stopPropagation();
        setExpandTransferType(!expandTransferType);
        setExpandFrom(false);
        setExpandTo(false);
    }

    const selectFrom=(e)=>{
        e.stopPropagation();
        setExpandFrom(!expandFrom);
        setExpandTo(false);
        setExpandTransferType(false);
    }

    const selectTo=(e)=>{
        e.stopPropagation();
        setExpandTo(!expandTo);
        setExpandFrom(false);
        setExpandTransferType(false);
    }

    let handleSubmit = async (event) => {
        event.preventDefault();
        // dispatch(setIsLoading(true))
      try {
        setIsSubmitting(true)
        const validateErrors = validate();
        if(Object.keys(validateErrors).length > 0) {
            return setErrors(validateErrors)
        } else {
            setErrors({})
        };
            
         const requestId = uuidv4(); 
         const result = await createTransferService({
                requestId,
                fromAgentId: transferFrom.agentId,
                toUserId: transferTo.userId,
                transactionTypeId: transferType.transactionTypeId,
                amount: amount,
                type: 'inward'
            });


            if(result.success) {
                dispatch(
                    setToastMessage({
                    message: "Success",
                    type: "success",
                    })
                );
                // navigate('/transfer-history');
                setTimeout(() => {
                    window.location.reload();
                }, 500)
            }
            } catch (error) {
                const errorMessage =
                    error?.response?.data?.error?.includes('streaming buffer')
                        ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                        : error?.response?.data?.message || error?.message;

                dispatch(
                    setToastMessage({
                        message: errorMessage,
                        type: "error",
                    })
                );
            }  finally {
              setIsSubmitting(false)
            }
    }

    const validate = () => {
        let errors = {};
        if(!transferFrom.agentId) {
            errors.transferFrom = 'transferFrom is required';
        }else if(!transferTo.userId) {
            errors.transferTo = 'transferTo is required';
        }else if(!transferType.transactionTypeId) {
            errors.transferType = 'transferType is required';
        }else if(!amount) {
            errors.amount = 'Amount is required';
        }

        return errors;
    }

    // const createAction = async () => {
    //     // dispatch(setIsLoading(true))

    //     try {
    //         let result;
    //         result = await createTransferService({
    //             fromAgentId: transferFrom.agentId,
    //             toUserId: transferTo.userId,
    //             transactionTypeId: transferType.transactionTypeId,
    //             amount: amount,
    //             type: 'inward'
    //         });


    //         if(result.success) {
    //             dispatch(
    //                 setToastMessage({
    //                 message: result.data.message,
    //                 type: "success",
    //                 })
    //             );
    //             // navigate('/transfer-history');
    //             // setTimeout(() => {
    //             //     window.location.reload();
    //             // }, 300)
    //         }
    //         } catch (error) {
    //             const errorMessage =
    //                 error?.response?.data?.error?.includes('streaming buffer')
    //                     ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
    //                     : error?.response?.data?.message || error?.message;

    //             dispatch(
    //                 setToastMessage({
    //                     message: errorMessage,
    //                     type: "error",
    //                 })
    //             );
    //         } finally {
    //         dispatch(setIsLoading(false))
    //     }
    // }

    return (
        <div>
            <form className='flex flex-col gap-5 justify-center items-center h-[60%] w-60 mx-auto' onSubmit={handleSubmit}>

                    <TransferFromSB
                        transferFrom={transferFrom}
                        setTransferFrom={setTransferFrom}
                        selectFrom={selectFrom}
                        transferFromData={transferFromData}
                        setExpandFrom={setExpandFrom}
                        expandFrom={expandFrom}
                    />

                    { errors.transferFrom && <div className='text-red'>{errors.transferFrom}</div> }

                    <TransferToSB
                        transferTo={transferTo}
                        setTransferTo={setTransferTo}
                        selectTo={selectTo}
                        transferToData={transferToData}
                        setExpandTo={setExpandTo}
                        expandTo={expandTo}
                    />

                    { errors.transferTo && <div className='text-red'>{errors.transferTo}</div> }

                    <TransferTypeSB
                        transferType={transferType}
                        setTransferType={setTransferType}
                        selectTransferType={selectTransferType}
                        transferTypeData={transferTypeData}
                        setExpandTransferType={setExpandTransferType}
                        expandTransferType={expandTransferType}
                        shadow={true}
                    />

                    { errors.transferType && <div className='text-red'>{errors.transferType}</div> }

                <input
                    type="number"
                    value={amount}
                    ref={inputRef}
                    onFocus={handleFocus}
                    onWheel={handleWheel}
                    placeholder='Amount'
                    className='bg-bgColor rounded-sm py-2 px-3  w-full outline-none shadow-lg '
                    onChange={(e) => setAmount(parseFloat(e.target.value))}
                />

                { errors.amount && <div className='text-red'>{errors.amount}</div> }

                <div className='flex flex-col gap-5 w-full items-end mt-16 text-white font-semibold'>
                    <button type='submit' 
                        className='bg-blue-500 rounded-full py-2 w-40 shadow-3xl '
                        disabled={isSubimtting}
                        >
                      {isSubimtting ? <FaSpinner className="animate-spin text-2xl text-green-500" />  :"Agent to Me"}
                    </button>
                    {/* <button className='bg-buttonRed rounded-sm py-2 w-32'>Cancel</button> */}
                </div>
            </form>
        </div>
    )
}

export default TransferAtoU
